import './lineItemsTableHeader.scss';

import { CSSProperties, FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { ColumnDefinition, LineItem } from '../../selectors/types/ColumnDefinition';

interface LineItemsTableHeaderProps {
    className?: string;
    columnDefinitions: Array<ColumnDefinition<LineItem>>;
    lineItems: LineItem[];
}

function getColumnStyle(colDef: ColumnDefinition<LineItem>): CSSProperties | undefined {
    return colDef.flexGrow !== undefined
        ? {
              flexGrow: colDef.flexGrow,
          }
        : colDef.fixedWidth
          ? {
                flex: 'none',
                width: `${colDef.fixedWidth}px`,
            }
          : undefined;
}

const bem = bemFactory.block('reqf-line-items-table-header');
const qa = bemFactory.qa('reqf-line-items-table-header');

const LineItemsTableHeader: FC<LineItemsTableHeaderProps> = (props) => {
    const { className, columnDefinitions, lineItems } = props;

    return (
        <div className={bem.add(className)()} data-qa={qa()}>
            {columnDefinitions.map((colDef) => (
                <div
                    data-qa={qa('column')}
                    data-qa-id={colDef.id}
                    data-qa-name={colDef.name}
                    key={colDef.id}
                    className={bem('column', { right: colDef.alignRight })}
                    title={colDef.title || colDef.name}
                    style={getColumnStyle(colDef)}
                >
                    {colDef.headerCell ? colDef.headerCell(lineItems) : colDef.name}
                </div>
            ))}
        </div>
    );
};

export default memo(LineItemsTableHeader);
